import React, { Component } from 'react';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'react-final-form';
import Translate from 'react-translate-component';
import { isNil } from 'ramda';

import { getDepartment } from 'actions/asyncActions';
import Select from 'components/common/form/Select';

@withAsyncActions(props => ({
    getDepartment: getDepartment
        .withPayload(props => ({
            company: props.organization
        }))
        .withOptions({
            dispatchOnUpdate: !isNil(props.organization),
            autoReset: true,
            dispatchOnMount: !isNil(props.organization)
        })
}))
export default class DepartmentField extends Component {
    render() {
        const { getDepartment, organization, disabled, name } = this.props;

        return <Field
            name={name || 'department'}
            allowClear
            showSearch
            component={Select}
            options={getDepartment.data}
            disabled={!organization || disabled}
            dictionaryAction={getDepartment}
            label={{ content: 'request.department' }}
            className='form-control'
            placeholder={<Translate content='placeholders.chooseDepartment' />}
        />;
    }
}
